import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@common/components/components.module';
import { LoginGuardService } from '@common/services/LoginGuardService/LoginGuardService';
import { AuthGuardService } from '@common/services/AuthGuardService/AuthGuardService';
import { LoginViewComponent } from '@modules/auth/views/loginView/loginView.component';
import { LogoutViewComponent } from '@modules/auth/views/logoutView/logoutView.component';
import { ForgottenPasswordViewComponent } from './views/forgottenPasswordView/forgottenPasswordView.component';
import { PasswordResetConfirmViewComponent } from './views/PasswordResetConfirmView/passwordResetConfirmView.component';
import { MicrosoftLoginViewComponent } from './views/microsoftLoginView/microsoftLoginView.component';

const routes: Routes = [
  {
    path: 'auth',
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', canActivate: [LoginGuardService], component: LoginViewComponent },
      { path: 'logout', canActivate: [AuthGuardService], component: LogoutViewComponent },
      { path: 'forgotten-password', canActivate: [LoginGuardService], component: ForgottenPasswordViewComponent },
    ],
  },
  {
    path: 'oauth',
    canActivate: [LoginGuardService],
    children: [
      { path: 'microsoft', component: MicrosoftLoginViewComponent },
    ],
  },
  {
    path: 'password/reset/confirm/:uid/:token', canActivate: [LoginGuardService], component: PasswordResetConfirmViewComponent,
  },
];

@NgModule({
  declarations: [
    LoginViewComponent,
    LogoutViewComponent,
    ForgottenPasswordViewComponent,
    PasswordResetConfirmViewComponent,
    MicrosoftLoginViewComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    TranslateModule,
    ComponentsModule,
  ],
  exports: [
    RouterModule,
  ],
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/modules/auth/auth.module.ts